import Vue from 'vue'
import { Toast } from 'vant'
import axios from 'axios'
import { development, production } from '../config'
// import qs from 'qs'
Vue.use(Toast)

// 创建Axios实例
const Service = axios.create({
  timeout: 1000 * 10,
  baseURL: process.env.NODE_ENV === 'production' ? production : development,
  method: 'get',
  headers: {
    tenant_id: sessionStorage.getItem('tenantId'),
    'Content-Type': 'application/json;charset=utf-8'
  },
  withCredentials: true
})

// 添加请求拦截器
Service.interceptors.request.use(
  config => config,
  error => Promise.reject(error)
)

// 添加响应拦截器
Service.interceptors.response.use(
  response => {
    console.log(response.data.code.toString())
    if (response.data.code.toString().startsWith('2')) {
      return response.data
    } else {
      Toast(response.data.message)
      return Promise.reject(response.data.message)
    }
  },
  error => {
    Toast(error.message)
    return Promise.reject(error)
  }
)

/**
 * 封装get方法
 * @param  {String} url    [请求的url地址]
 * @param  {Object} params [请求时携带的参数]
 */
export function GET (url, params = {}) {
  return new Promise((resolve, reject) => {
    Service.get(url, { params })
      .then(res => resolve(res))
      .catch(err => reject(err))
  })
}

/**
 * 封装post方法
 * @param {String} url  [请求的url地址]
 * @param {Object} data [请求时携带的参数]
 */
export function POST (url, data, isFormData = false) {
  if (isFormData) {
    var formData = new FormData()
    formData.append('file', data)
  }
  return new Promise((resolve, reject) => {
    Service.post(url, formData || data)
      .then((res) => resolve(res))
      .catch(err => reject(err))
  })
}

/**
 * 封装delete方法
 * @param  {String} url    [请求的url地址]
 * @param  {Object} params [请求时携带的参数]
 */
export function DELETE (url, params = {}) {
  return new Promise((resolve, reject) => {
    Service.delete(url, { params })
      .then(res => resolve(res))
      .catch(err => reject(err))
  })
}

export default Service
